module.exports = __webpack_public_path__ + "static/media/originalDesign.e17000fa.png";


//////////////////
// WEBPACK FOOTER
// ./src/asets/originalDesign.png
// module id = 688
// module chunks = 0